import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { PiasLayoutComponent } from '../../shared/components/pias-layout/pias-layout.component';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { DashboardComponentsModuleV2 } from './dashboard-components/dashboard-components-module-v2';
import { SessionStorageService } from '../../core/services/session-storage/session-storage.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SelectOptions } from '../../core/interfaces/select-options.interface';
import { MatDialog } from '@angular/material/dialog';
import { EventTrainingDialogDialog } from '../events-training/event-training-dialog/event-training-dialog.dialog';

@Component({
  selector: 'app-dashboard-v2',
  imports: [
    CommonModule,
    PiasLayoutComponent,
    MatCardModule,
    MatTabsModule,
    ReactiveFormsModule,
    DashboardComponentsModuleV2
  ],
  standalone: true,
  templateUrl: './dashboard-v2.page.html',
  styleUrl: './dashboard-v2.page.scss'
})
export class DashboardPageV2 implements OnInit {

  private sessionStorageService = inject(SessionStorageService);
  private readonly matDialog = inject(MatDialog);

  protected selectedTabId: string = "";
  protected currentUserRole: string = "";
  protected currentUserGroup: string = "";
  protected currentUserModel: string = "";

  protected targetYearOptions: SelectOptions[] = [];
  protected targetYearFc = new FormControl();

  protected isAffinityUser = signal(false);


  protected currentYear: number = new Date().getFullYear();
  protected previousYear: number = this.currentYear - 1;

  constructor() { }

  ngOnInit(): void {
    if (!sessionStorage.getItem('popupShown')) {
      this.openDialog();
      sessionStorage.setItem('popupShown', 'true');
    }

    this.selectedTabId = "ape";

    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.currentUserGroup = this.sessionStorageService.getCurrentUserGroup();
    this.currentUserModel = this.sessionStorageService.getCurrentUserModel();

    // Generating Target Year Options
    this.targetYearOptions.push({
      name: this.previousYear.toString(),
      value: this.previousYear.toString()
    });

    this.targetYearOptions.push({
      name: this.currentYear.toString(),
      value: this.currentYear.toString()
    });

    // Setting default target year.
    if (new Date().getMonth() == 0) {
      this.targetYearFc.setValue(this.previousYear.toString());
    } else {


      this.targetYearFc.setValue(this.currentYear);
    }

    // if (['Affinity'].includes(this.currentUserGroup) && ['', 'Model_A', 'Model_B'].includes(this.currentUserModel)) {
    //   this.isAffinityUser.set(true);
    // }
  }

  protected __onDashboardTabChange(event: MatTabChangeEvent) {
    if (event.tab.id) {
      this.selectedTabId = event.tab.id.toString();
    } else {
      console.error(`Invalid tab ID for mat-tab[${event.index}]`);
    }
  }

  openDialog() {
    const viewEventtrainingDialogRef = this.matDialog.open(EventTrainingDialogDialog, {
      width: '70vw',
      maxWidth: '70vw',
      disableClose: true,
      panelClass: 'center-dialog',
      position: {
        right: '150px',
      }
    });
  }

}
